import { useMemo, useState } from 'react';
import AnalyticsContext from './AnalyticsContext';
import {
  AnalyticsBasicProperty,
  AnalyticsFilter,
} from './analytics/types/Analytics.types';
import { HostQualityFilter } from './hostQuality/types/HostQuality.types';

const AnalyticsContextProvider = ({
  // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  children,
  // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  analyticsFilterLocalStorageKey,
  // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  chartsFilterLocalStorageKey,
}) => {
  const [allProperties, setAllProperties] = useState<AnalyticsBasicProperty[]>(
    [],
  );

  const [filter, setFilter] = useState<AnalyticsFilter>();
  const [hostQualityFilter, setHostQualityFilter] =
    useState<HostQualityFilter>();
  const [leadChannels, setLeadChannels] = useState([]);
  const [employees, setEmployees] = useState([]);

  const contextValue = useMemo(
    () => ({
      allProperties,
      setAllProperties,
      filter,
      setFilter,
      hostQualityFilter,
      setHostQualityFilter,
      leadChannels,
      setLeadChannels,
      employees,
      setEmployees,
      analyticsFilterLocalStorageKey,
      chartsFilterLocalStorageKey,
    }),
    [
      allProperties,
      filter,
      hostQualityFilter,
      leadChannels,
      employees,
      analyticsFilterLocalStorageKey,
      chartsFilterLocalStorageKey,
    ],
  );

  return (
    // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    <AnalyticsContext.Provider value={contextValue}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export default AnalyticsContextProvider;
